<template>
    <div class="padding" style="text-align: left; font-size: 14px">
        <div class="header">
            <h1>{{noticeTitle}}</h1>
            <div class="avatar">
                <img :src="infoData.portraitImgUrl">
                <span style="font-size: 15px">{{infoData.realName}}</span>
            </div>
            <div class="header-footer">
                <div class="datetime">
                    <span>{{moment(infoData.createdTime).format('YYYY-MM-DD HH:mm')}}</span>
                </div>
                <div class="type">
                    #{{noticeType}}
                </div>
            </div>
        </div>
        <div class="content" v-html="noticeContent"></div>
        <div v-if="infoData.canDownload && infoData.attachList && infoData.attachList.length > 0">
            <div v-for="(attach,n) in infoData.attachList" :key="n">
                <div class="detail-row-attach" @click="preview(attach);">
                    <img class="portrait-size-30" :src="fileTypeImg(attach.title)">
                    <div
                        style="flex-grow: 1; display: flex; flex-direction: column; margin-left: 10px; align-items: start">
                        <span style="color: #333; font-size: 13px">{{attach.title}}</span>
                        <span
                            style="color: #999; font-size: 12px; margin-top: 4px;">{{attach.size}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import head from '@/mixins/head';
    import storeOrder from '@/mixins/store-order';

    export default {
        name: 'notice-detail',
        components: {},
        mixins: [head, storeOrder],
        data() {
            return {
                infoData: ''
            };
        },
        created() {
            this.inited();
            this.queryInfo();
        },
        mounted() {
        },
        watch: {
            '$route': 'inited' // 如果路由有变化，会再次执行该方法
        },
        computed: {

            noticeTitle() {
                let result = '';
                if (this.$route.query.type == 1 || this.$route.query.type == 3) {
                    result = this.infoData.noticeTitle;
                } else if (this.$route.query.type == 2 || this.$route.query.type == 4) {
                    result = this.infoData.institutionTitle;
                }
                return result;
            },

            noticeType() {
                let result = '';
                if (this.$route.query.type == 1 || this.$route.query.type == 3) {
                    result = this.infoData.noticeTypeName;
                } else if (this.$route.query.type == 2 || this.$route.query.type == 4) {
                    result = this.infoData.institutionTypeName;
                }
                return result;
            },

            noticeContent() {
                let result = '';
                if (this.$route.query.type == 1 || this.$route.query.type == 3) {
                    result = this.infoData.noticeDes;
                } else if (this.$route.query.type == 2 || this.$route.query.type == 4) {
                    result = this.infoData.institutionDes;
                }
                return result;
            }

        },
        methods: {
            inited() {
            },

            preview(attach) {
                window.filePreview({
                    fileId: attach.fileId,
                    name: attach.title,
                    size: attach.sizeNumber
                });
            },

            fileTypeImg(name) {
                return window.getFileTypeImg(name);
            },

            queryInfo() {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let type = this.$route.query.type;
                let param, url;
                if (type == 1) {
                    param = {
                        cnId: this.$route.query.id
                    };
                    url = '/oa/queryNoticeDetail.do';
                } else if (type == 2) {
                    param = {
                        ciId: this.$route.query.id
                    };
                    url = '/zhidu/queryZhiduDetail.do';
                } else if (type == 3) {
                    param = {
                        cnId: this.$route.query.id
                    };
                    url = '/oa/queryNoticeDetailManage.do';
                } else if (type == 4) {
                    param = {
                        ciId: this.$route.query.id
                    };
                    url = '/zhidu/queryZhiduDetailManage.do';
                }
                this.$http.post(url, param).then((response) => {
                    this.$toast.clear();
                    if (response.data) {
                        // if (type == 2) {
                        //     if (response.data.length > 0) {
                        //         this.infoData = response.data[0];
                        //     }
                        // } else {
                        this.infoData = response.data;
                        // }
                    }
                    this.markRead();
                }).catch((error) => {
                    this.$toast.clear();
                });
            },

            markRead() {
                let url = '/common/deleteCompanyUnRead.do';
                let moduleCd;
                if (this.$route.query.type == 1 || this.$route.query.type == 3) {
                    moduleCd = 'companynotice';
                } else if (this.$route.query.type == 2 || this.$route.query.type == 4) {
                    moduleCd = 'companyinstitution';
                }
                let param = {
                    moduleCd: moduleCd,
                    moduleId: this.$route.query.id
                };

                this.$http.post(url, param, { toast: false }).then((response) => {
                    console.log('markRead', response);
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/approve.scss';
    @import '../../assets/scss/approve.scss';
    .header {
    }

    .header h1 {
        margin-top: 15px;
        margin-bottom: 15px;
        font-size: 26px;
        color: #3a3a3a;
        font-weight: 400;
    }

    .header .avatar {
        display: block;
        height: 36px;
        line-height: 36px;
    }

    .header .avatar img {
        display: inline-block;
        border-radius: 18px;
        width: 36px;
        height: 36px;
    }

    .header .avatar span {
        margin-left: 15px;
        display: inline-block;
        color: #3a3a3a;
        font-size: 18px;
        vertical-align: top;
        font-weight: 400;
    }

    .header .header-footer {
        display: block;
        margin-bottom: 25px;
    }

    .header .header-footer .datetime, .header .header-footer .type {
        display: inline-block;
        font-size: 15px;
    }

    .header .header-footer .datetime {
        color: #777;
        font-weight: 300;
    }

    .header .header-footer .type {
        color: #07affa;
        margin-left: 15px;
    }

    .padding {
        padding: 15px;
    }

    .content p {
        font-size: 16px;
        font-weight: 300;
        color: #3a3a3a;
        line-height: 28px;
    }

    .content img {
        display: block;
        max-width: 100%;
        vertical-align: middle;
        text-align: center;
        margin: 20px auto;
    }

    .editor-table {
    }

    table {
        border: 1px solid #f2f2f2;
        width: 100%;
    }

    td {
        border-bottom: 1px solid #f2f2f2;
        border-right: 1px solid #f2f2f2;
        line-height: 36px;
        height: 36px;
        padding: 0 10px;
    }

    tr td:last-child {
        border-right: 0
    }

    tr:first-child {
        border-right: 0;
    }

    .cell-item-attach {
        background-color: #f8f8f8;
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 5px 10px 5px 10px;
    }

    .detail-row-attach {
        margin-top: 10px;
        background-color: #f5f5f5;
        display: flex;
        flex-direction: row;
        padding: 10px;
        margin-bottom: 5px;
    }
</style>
